export enum PanelPattern {
  Solid,
  Columns,
  Checkerboard,
  HorizontalBand,
  Rows,
  Quarters,
  HorizontalSplit,
  Unknown
}
